// extracted by mini-css-extract-plugin
module.exports = {"message":"VercelStartInstallation_message__zqKC2","button":"VercelStartInstallation_button__d2As0"};